import { render, staticRenderFns } from "./QApiQuery.vue?vue&type=template&id=60c385c9&scoped=true&"
import script from "./QApiQuery.vue?vue&type=script&lang=js&"
export * from "./QApiQuery.vue?vue&type=script&lang=js&"
import style0 from "./QApiQuery.vue?vue&type=style&index=0&id=60c385c9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60c385c9",
  null
  
)

export default component.exports